import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  currentId:number = 0;
  currentDatas:any;
  isLoading:boolean;
  closeEvents = new EventEmitter<void>();

  constructor() { }

  public display(modalId:number, datas:any = null){
    this.currentId = modalId;
    this.currentDatas = datas;
  }

  public close(){
    this.currentId = MODAL.NONE;
    this.currentDatas = null;
    this.closeEvents.emit(null);
  }
}

export enum MODAL {
  NONE,
  PROJECTS,
  SEARCH_CUSTOMER,
  PRICE_INFOS,
  PRODUCTS_LIST,
  PRINT_MEDIAS,
  IMAGE_ZOOM,
  PROJECT_DELETE,
  PROJECT_DUPLICATE,
  PROMPT,
  ASSISTANCE,
  STORE_STOCK,
  ORDER_MESSAGE,
  SHARE
}
